import { IPataviumPagedResponse } from '../../helpers/response.class';
import { IView } from '../request-and-responses/rest-api/interfaces/view';

export interface IEnabledView {
    [key: string]: boolean;
}
export interface IOperatorEnabledViews {
    //Dashboard
    Dashboard: boolean;
    //Agenti e agenzie
    Agenti: boolean;
    Agenzie: boolean;
    //Clienti e contratti
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    //Area commerciale
    Listini: boolean;
    Documenti: boolean;
    //Loyalty e Carte
    LoyaltyECarte: boolean;
    //Comunicazioni
    Comunicazioni: boolean;
    //Statistiche
    Statistiche: boolean;
    //Profilo e impostazioni
    Profilo: boolean;
}
export interface IAgencyEnabledViews {
    //Dashboard
    Dashboard: boolean;
    //Agenti e Operatori Agenzia
    Agenti: boolean;
    OperatoriAgenzia: boolean;
    //Clienti e contratti
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    //Area commerciale
    Listini: boolean;
    Documenti: boolean;
    //Comunicazioni
    ComunicazioniPatavium: boolean;
    ComunicazioniAgenti: boolean;
    //Statistiche
    Statistiche: boolean;
    //Profilo e impostazioni
    Profilo?: boolean;
}
export interface IAgencyOperatorEnabledViews {
    //Dashboard
    Dashboard: boolean;
    //Agenti
    Agenti: boolean;
    //Clienti e contratti
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    //Area commerciale
    Listini: boolean;
    Documenti: boolean;
    //Comunicazioni
    ComunicazioniPatavium: boolean;
    ComunicazioniAgenti: boolean;
    //Statistiche
    Statistiche: boolean;
    //Profilo e impostazioni
    Profilo?: boolean;
}
export interface IAgentEnabledViews {
    //Dashboard
    Dashboard: boolean;
    //Clienti e contratti
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    //Area commerciale
    Listini: boolean;
    Documenti: boolean;
    //Comunicazioni
    Comunicazioni: boolean;
    //Statistiche
    Statistiche: boolean;
    //Profilo e impostazioni
    Profilo: boolean;
}

export class OperatorEnabledViews implements IOperatorEnabledViews {
    Dashboard: boolean;
    Agenti: boolean;
    Agenzie: boolean;
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    Listini: boolean;
    Documenti: boolean;
    LoyaltyECarte: boolean;
    Comunicazioni: boolean;
    Statistiche: boolean;
    Profilo: boolean;

    constructor(resp: IPataviumPagedResponse<IView>) {
        for (const elem of resp.payload) {
            const name = elem.name;
            const value = elem.canBeVisited;
            switch (name) {
                case 'Dashboard':
                    this.Dashboard = value;
                    break;
                case 'Venditori':
                    this.Agenti = value;
                    break;
                case 'Team':
                    this.Agenzie = value;
                    break;
                case 'Gestione Contratti':
                    this.GestioneContratti = value;
                    break;
                case 'Gestione Clienti':
                    this.GestioneClienti = value;
                    break;
                case 'Listini':
                    this.Listini = value;
                    break;
                case 'Documenti':
                    this.Documenti = value;
                    break;
                case 'Loyalty e Carte':
                    this.LoyaltyECarte = value;
                    break;
                case 'Comunicazioni':
                    this.Comunicazioni = value;
                    break;
                case 'Statistiche':
                    this.Statistiche = value;
                    break;
                case 'Profilo':
                    this.Profilo = value;
                    break;
                default:
                    console.log('OPERATORE VIEW', name);
                    break;
            }
        }
    }
}

export class AgencyEnabledViews implements IAgencyEnabledViews {
    Dashboard: boolean;
    Agenti: boolean;
    OperatoriAgenzia: boolean;
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    Listini: boolean;
    Documenti: boolean;
    ComunicazioniPatavium: boolean;
    ComunicazioniAgenti: boolean;
    Statistiche: boolean;
    Profilo?: boolean;

    constructor(resp: IPataviumPagedResponse<IView>) {
        for (const elem of resp.payload) {
            const name = elem.name;
            const value = elem.canBeVisited;
            switch (name) {
                case 'Dashboard':
                    this.Dashboard = value;
                    break;
                case 'Venditori':
                    this.Agenti = value;
                    break;
                case 'Operatori Team':
                    this.OperatoriAgenzia = value;
                    break;
                case 'Gestione Contratti':
                    this.GestioneContratti = value;
                    break;
                case 'Gestione Clienti':
                    this.GestioneClienti = value;
                    break;
                case 'Listini':
                    this.Listini = value;
                    break;
                case 'Documenti':
                    this.Documenti = value;
                    break;
                case 'Comunicazioni Patavium':
                    this.ComunicazioniPatavium = value;
                    break;
                case 'Comunicazioni Venditori':
                    this.ComunicazioniAgenti = value;
                    break;
                case 'Statistiche':
                    this.Statistiche = value;
                    break;
                case 'Profilo':
                    this.Profilo = value;
                    break;
                default:
                    console.error('AGENCY VIEW', name);
                    break;
            }
        }
    }
}

export class AgentEnabledViews implements IAgentEnabledViews {
    Dashboard: boolean;
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    Listini: boolean;
    Documenti: boolean;
    Comunicazioni: boolean;
    Statistiche: boolean;
    Profilo: boolean;
    constructor(resp: IPataviumPagedResponse<IView>) {
        for (const elem of resp.payload) {
            const name = elem.name;
            const value = elem.canBeVisited;
            switch (name) {
                case 'Dashboard':
                    this.Dashboard = value;
                    break;
                case 'Gestione Contratti':
                    this.GestioneContratti = value;
                    break;
                case 'Gestione Clienti':
                    this.GestioneClienti = value;
                    break;
                case 'Listini':
                    this.Listini = value;
                    break;
                case 'Documenti':
                    this.Documenti = value;
                    break;
                case 'Comunicazioni':
                    this.Comunicazioni = value;
                    break;
                case 'Statistiche':
                    this.Statistiche = value;
                    break;
                case 'Profilo':
                    this.Profilo = value;
                    break;
                default:
                    console.error('AGENT VIEW', name);
                    break;
            }
        }
    }
}

export class AgencyOperatorEnabledViews implements IAgencyOperatorEnabledViews {
    Dashboard: boolean;
    Agenti: boolean;
    GestioneContratti: boolean;
    GestioneClienti: boolean;
    Listini: boolean;
    Documenti: boolean;
    ComunicazioniPatavium: boolean;
    ComunicazioniAgenti: boolean;
    Statistiche: boolean;
    Profilo?: boolean;

    constructor(resp: IPataviumPagedResponse<IView>) {
        for (const elem of resp.payload) {
            const name = elem.name;
            const value = elem.canBeVisited;
            switch (name) {
                case 'Dashboard':
                    this.Dashboard = value;
                    break;
                case 'Venditori':
                    this.Agenti = value;
                    break;
                case 'Gestione Contratti':
                    this.GestioneContratti = value;
                    break;
                case 'Gestione Clienti':
                    this.GestioneClienti = value;
                    break;
                case 'Listini':
                    this.Listini = value;
                    break;
                case 'Documenti':
                    this.Documenti = value;
                    break;
                case 'Comunicazioni Patavium':
                    this.ComunicazioniPatavium = value;
                    break;
                case 'Comunicazioni Venditori':
                    this.ComunicazioniAgenti = value;
                    break;
                case 'Statistiche':
                    this.Statistiche = value;
                    break;
                case 'Profilo':
                    this.Profilo = value;
                    break;
                default:
                    console.error('AGENCY VIEW', name);
                    break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/frontend/enabled-views.ts